<nav
    aria-label="Global"
    class="rcp-border-b-[1px] rcp-border-ul-gray-400"
>
    <div
        class="rcp-inline-flex rcp-w-full rcp-items-center rcp-justify-between rcp-gap-5 rcp-align-middle"
    >
        <ul class="rcp-flex-auto">
            <li class="rcp-list-none">
                @for (nav of navs(); track nav.navId) {
                    <a
                        *appIsGranted="nav.roles"
                        class="rcp-inline-block rcp-border-b-2 rcp-border-transparent rcp-px-4 rcp-py-[14px] rcp-text-sm/5 rcp-font-medium rcp-text-ul-dark-300 [&.active-page]:rcp-border-ul-blue-400 [&.active-page]:rcp-text-ul-dark-400"
                        routerLinkActive="active-page"
                        [attr.data-testid]="
                            'rcp-sublink-' + nav.displayText.replaceAll(' ', '-')
                                | lowercase
                        "
                        routerLink="{{ nav.targetUrl }}"
                        >{{ nav.displayText }}</a
                    >
                }
            </li>
        </ul>
    </div>
</nav>
